module.exports = __webpack_public_path__ + "images/20b0db97b9d80f11b323010efb3abd1e-IMG_6031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_6031.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_6031.jpg
// module chunks = 0